module.exports = __webpack_public_path__ + "img/youtube.4a1994e8.svg";